import { DateTime } from "luxon";

export enum HotelPickupReasons {
    BANDAGE = "Bandage",
    OPERATION = "Operation",
    RHINO_MEDICAL = "RhinoMedical",
    YES_SMILE = "YesSmile",
    OTHER = "Other",
}
export type OperationHotelResponseType<T, D extends "api" | "local"> = {
    id?: string;
    notes?: string;
    flight?: {
        arrival_date?: string;
        arrival_time?: string;
        arrival_offset?: string;
        arrival_airport?: string;
        arrival_flight_number?: string;
        departure_date?: string;
        departure_time?: string;
        departure_offset?: string;
        departure_airport?: string;
        departure_flight_number?: string;
    };
    pickupReason?: HotelPickupReasons;
    pickupTime: D extends "local" ? DateTime | null : string | null;
    pickupLocation: string | null;
    isRegistered: boolean;
    companions?: T[];
    cancelled: boolean;
    stageNumber?: number;
};
